export default __webpack_public_path__ + "static/media/placeholder_dummy2016-architekturbuero01-de.1192d390.png";